export const isDateInInterval = (dateToCheck: Date): boolean => {
  // console.log(dateToCheck);
  const now = new Date();

  const currentMonth = now.getMonth() + 1;

  let startDate: Date;
  let endDate: Date;

  if (currentMonth >= 8 && currentMonth <= 12) {
    startDate = new Date(now.getFullYear(), 8, 1);
    endDate = new Date(now.getFullYear(), 11, 31);
  } else if (currentMonth >= 1 && currentMonth < 8) {
    startDate = new Date(now.getFullYear(), 0, 1);
    endDate = new Date(now.getFullYear(), 5, 30);
  } else {
    return false;
  }
  console.log(dateToCheck >= startDate && dateToCheck <= endDate);
  return dateToCheck >= startDate && dateToCheck <= endDate;
};
